import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'app',
		pathMatch: 'full',
	},
	{
		path: 'app',
		loadChildren: () => import('./central/central.module').then(m => m.CentralModule)
	},
	{
		path: 'auth',
		loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
	}
];

@NgModule({
	imports: [
		RouterModule,
		RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
		// RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', enableTracing: true }),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
